import { ButtonOutlineMedium } from '@/design-system';
import { Divider } from '@/components';
import { FlyerType } from '@/config/constants';
import newSchoolFlyers from '@/assets/new_school_flyers.svg';
import newCommFreeFlyers from '@/assets/new_comm_free_flyers.svg';
import styles from './BottomViewFlyers.styles';
import { findFirstFocusableElement } from '@/utils';
import colors from '@/theme/colors';

interface BottomViewFlyersProps {
  variant: FlyerType.school | FlyerType.community;
  label?: string;
  onClick?: () => void;
}

export const BottomViewFlyers: React.FC<BottomViewFlyersProps> = ({ variant, label, onClick }) => {
  const handleClick = () => {
    if (!onClick) return;
    onClick();
    setTimeout(() => {
      const focusableElement = findFirstFocusableElement();
      if (focusableElement) {
        focusableElement.focus();
      }
    }, 2000);
  };

  return (
    <section className={styles.container}>
      <div className={styles.dividerPadding}>
        <Divider />
      </div>

      {onClick && (
        <div className={styles.buttonContainer}>
          <ButtonOutlineMedium
            onClick={handleClick}
            className={styles.button}
            fontColor={colors.shadesJungle800}
          >
            {label}
          </ButtonOutlineMedium>
        </div>
      )}
      <div className={styles.illustrationContainer}>
        <img
          src={variant === FlyerType.school ? newSchoolFlyers : newCommFreeFlyers}
          alt=""
          className={styles.illustration}
        />
      </div>
    </section>
  );
};
